import React from 'react';
import FontsDefault from '../../Assistant/DefaultStyle';

import {
  AiOutlineCode,
  AiOutlineAntDesign,
  AiOutlineTeam,
  AiOutlineSafety,
  AiFillAndroid,
  AiFillDatabase,
  AiFillAppstore,
} from 'react-icons/ai';

function Card({
  title,
  description,
  AiOutlineCodeIcon,
  AiOutlineAntDesignIcon,
  AiOutlineTeamIcon,
  AiOutlineSafetyIcon,
  AiFillAndroidIcon,
  AiFillDatabaseIcon,
  AiFillAppstoreIcon,
}) {
  return (
    <div
      className={`p-6 shadow-md shadow-gray300 bg-textColor rounded-lg border-1 border-gray700`}
    >
      <div>
        {AiOutlineCodeIcon && (
          <AiOutlineCode className={`${FontsDefault.text6xl} text-amber`} />
        )}
        {AiOutlineAntDesignIcon && (
          <AiOutlineAntDesign
            className={`${FontsDefault.text6xl} text-amber`}
          />
        )}
        {AiOutlineTeamIcon && (
          <AiOutlineTeam className={`${FontsDefault.text6xl} text-amber`} />
        )}
        {AiOutlineSafetyIcon && (
          <AiOutlineSafety
            className={`${FontsDefault.text6xl} text-amber`}
          />
        )}

        {AiFillAndroidIcon && (
          <AiFillAndroid className={`${FontsDefault.text6xl} text-amber`} />
        )}

        {AiFillDatabaseIcon && (
          <AiFillDatabase className={`${FontsDefault.text6xl} text-amber`} />
        )}

        {AiFillAppstoreIcon && (
          <AiFillAppstore className={`${FontsDefault.text6xl} text-amber`} />
        )}
      </div>
      <h5
        className={`mb-2 mt-4 ${FontsDefault.text2xl} font-bold tracking-tight text-gray700 `}
      >
        {title}
      </h5>
      <p className={`mb-3 text-lg text-gray700`}>
        {description}
      </p>
    </div>
  );
}

export default Card;
